import i18n from "../i18n";

// Libellés traduits des rôles et des permissions (codes techniques -> texte lisible).
//
//  - Rôles : en français, le nom/la description saisis en base font foi (un
//    administrateur peut les renommer) ; dans les autres langues on utilise la
//    traduction du code (roles.<CODE>, roleDescriptions.<CODE>), avec repli sur
//    la base pour un rôle personnalisé sans traduction.
//  - Permissions : « Module : Action » traduit (permissionModules.<MODULE>,
//    permissionActions.<ACTION>), ou un libellé dédié permissionLabels.<CODE>
//    pour les permissions métier (EXAM_PUBLISH, ...). Une permission inconnue
//    (créée à la main) garde son module / action / code d'origine.

const isFrench = () => String(i18n.language || "fr").startsWith("fr");

export function roleName(t, role) {
  if (!role) return "";
  if (isFrench() && role.name) return role.name;
  return t(`roles.${role.code}`, { defaultValue: role.name || role.code });
}

export function roleDescription(t, role) {
  if (!role) return "";
  if (isFrench() && role.description) return role.description;
  return t(`roleDescriptions.${role.code}`, { defaultValue: role.description || "" });
}

export function permissionModuleLabel(t, module) {
  return t(`permissionModules.${module}`, { defaultValue: module });
}

export function permissionActionLabel(t, action) {
  return t(`permissionActions.${action}`, { defaultValue: action });
}

export function permissionLabel(t, permission) {
  if (!permission) return "";
  const fallback = `${permissionModuleLabel(t, permission.module)} : ${permissionActionLabel(t, permission.action)}`;
  return t(`permissionLabels.${permission.code}`, { defaultValue: fallback });
}

// Description d'une permission : celle de la base en français, sinon le libellé traduit.
export function permissionDescription(t, permission) {
  if (!permission) return "";
  if (isFrench() && permission.description) return permission.description;
  return permissionLabel(t, permission);
}
